import "./stockCheckLookUp.scss";
import React, { useCallback, useEffect, useState } from "react";
import ManagerNav from "../ManagerNav";
import axios from "axios";
import { TextField, Autocomplete, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

// Custom hook for debouncing
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};

const StockCheckLookUp = () => {
  const url = process.env.REACT_APP_DEPPLOYED;
  const [isLoading, setIsLoading] = useState();
  //user & site info
  const [sites, setSites] = useState([]);
  const [user, setUser] = useState();
  const [selectedSite, setSelectedSite] = useState();
  //search info
  //object of product
  const [searchProduct, setsearchProduct] = useState();
  const [tempSearchValue, setTempSearchValue] = useState();
  const [searchQuaryValue, setSearchQuaryValue] = useState("");
  const [searchOptions, setSearchOptions] = useState([]);
  //stock info
  const [stockCheckInfo, setStockCheckInfo] = useState();

  //regex for seachQuaryValue
  const checkSearchType = (string) => {
    const regex = /[a-zA-Z]/;
    if (regex.test(string)) {
      return "name";
    } else if (string.length > 8) {
      return "barcode";
    } else {
      return "number";
    }
  };

  //get user sites info
  useEffect(async () => {
    let userD = localStorage.getItem("userDetails");
    let user = JSON.parse(userD);
    setUser(user.user.user);
    await axios
      .post(`${url}/eposSQL/getSitesByName`, { sites: user.user.sites })
      .then(async (res) => {
        setSites(res.data);
        setSelectedSite(res.data[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  //search logic
  const performSearch = useCallback(async (value) => {
    if (!value) return;

    setIsLoading(true);
    setSearchOptions([]);
    let checkResult = checkSearchType(value);
    await axios
      .post(`${url}/eposProducts/searchProduct`, {
        name: checkResult == "name" ? value : "",
        productId: checkResult == "number" ? value : "",
        barcode:
          checkResult == "number" || checkResult == "barcode" ? value : "",
        eposId: checkResult == "number" ? value : "",
        productOrder: "",
        supplierId: "",
      })
      .then((res) => {
        setSearchOptions(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }, []);

  //perform search with delay
  const debouncedSearchQueryValue = useDebounce(searchQuaryValue, 500);
  useEffect(() => {
    if (debouncedSearchQueryValue) {
      performSearch(debouncedSearchQueryValue);
    }
  }, [debouncedSearchQueryValue, performSearch]);

  const handleTableData = async () => {
    if (!selectedSite || !searchProduct) {
      console.log("empty site or product");
      return;
    }
    setStockCheckInfo(null);
    const siteId = selectedSite.eposId;
    const productId = searchProduct.eposId; //productId in stockManamenetDB = eposId
    setIsLoading(true);
    await axios
      .get(`${url}/eposProducts/getStockCheckByProduct/${siteId}/${productId}`)
      .then((res) => {
        console.log("Response: ", res.data);
        let newResData=res.data.sort((a, b) => new Date(b.DateTime) - new Date(a.DateTime))
        newResData= newResData.slice(0,5).filter((data)=>data.StaffId!="163067")
        setStockCheckInfo(newResData);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  return (
    <div className="main">
      <ManagerNav />
      <h1>Stock Check Look Up</h1>
      <h2>{selectedSite ? selectedSite.siteName : null}</h2>
      {true ? (
        //sites.length > 1
        <div className="siteSelectorDiv">
          <select
            className="siteSelector"
            value={selectedSite ? selectedSite.eposId : ""}
            onChange={(e) => {
              const selectedSiteObject = sites.find(
                (site) => site.eposId == e.target.value
              );
              setSelectedSite(selectedSiteObject);
            }}
          >
            {sites.map((site, i) => {
              return (
                <option key={i} value={site.eposId}>
                  {site.siteName}
                </option>
              );
            })}
          </select>
        </div>
      ) : null}

      <div className="searchSection">
        <Autocomplete
          className="searchField"
          options={searchOptions}
          getOptionLabel={(option) => option.name || option.barcode}
          filterOptions={(x) => x}
          value={tempSearchValue}
          onChange={(e, newValue) => setsearchProduct(newValue)}
          inputValue={searchQuaryValue}
          onInputChange={(e, newValue) => {
            setSearchQuaryValue(newValue);
            setTempSearchValue(newValue);
          }}
          renderInput={(params) => (
            <TextField
              style={{ background: "white" }}
              {...params}
              label="Search"
              slotProps={{
                input: {
                  ...params.InputProps,
                  type: "search",
                  pattern: "[0-9]*",
                },
              }}
            ></TextField>
          )}
        />

        <Button
          color="primary"
          variant="contained"
          className="searchBtn"
          onClick={handleTableData}
        >
          <SearchIcon />
        </Button>
      </div>

      {stockCheckInfo ? (
        stockCheckInfo.length !== 0 ? (
          (
          (
            <table className="stockDataTable">
              <thead>
                <tr>
                  <th>StockID</th>
                  <th>Time</th>
                  <th>Date</th>
                  <th>Staff</th>
                  <th>Quantity -+</th>
                </tr>
              </thead>
              <tbody>
                {stockCheckInfo.map((stockCheck, i) => {
                  if (i < 5) {
                    let date = new Date(stockCheck.DateTime);
                    return (
                      <tr key={i}>
                        <td>{stockCheck.STakePid}</td>
                        <td>{date.toISOString().split("T")[1].slice(0, 8)}</td>
                        <td>{date.toISOString().split("T")[0]}</td>
                        <td>{stockCheck.StaffName}</td>
                        <td>{stockCheck.QtyAdjustment}</td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </table>
          ))
        ) : (
          <div className="noDataDiv">
            <h3 className="noDataHeader">No stock check data</h3>
          </div>
        )
      ) : null}
    </div>
  );
};

export default StockCheckLookUp;
